// extracted by mini-css-extract-plugin
export default {"note":"styles_note__GTEhS","st_v3":"styles_st_v3__e8t-d","title":"styles_title__b+P0f","noteWithoutRefund":"styles_noteWithoutRefund__2gyWF","ebookNote":"styles_ebookNote__WNnEG"};